import { createContext } from "react";

export type MissingFieldMessages = ReadonlyMap<string, string | undefined>;

export const MissingFieldsContext = createContext<MissingFieldMessages>(new Map());

const INDEX_SEGMENT = /\[(\d+)\]/g;

export function normalizeFieldPath(path: string): string {
  return path.replace(INDEX_SEGMENT, ".$1");
}

export function scopeMissingFields(messages: MissingFieldMessages, prefix: string): MissingFieldMessages {
  const scoped = new Map<string, string | undefined>();
  for (const [path, message] of messages) {
    if (path.startsWith(prefix)) {
      scoped.set(path.slice(prefix.length), message);
    }
  }
  return scoped;
}
